// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

.l7U3JLzydcprrdQn33A5 {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.EcJ0I7x4nEUGJH0gF64g {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 8px;
  flex-wrap: wrap;
}
@media (max-width: 768px) {
  .EcJ0I7x4nEUGJH0gF64g {
    width: 100%;
    justify-content: space-between;
  }
}

.A_6g9d9koNAcd_yZsEUW {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}

.W3orC2Go0VD5GEJL5mb9 {
  display: flex;
  align-items: flex-end;
  gap: 4px;
}
.W3orC2Go0VD5GEJL5mb9 button.folder-tab-small-no-width,
.W3orC2Go0VD5GEJL5mb9 button.folder-tab-selected-small-no-width {
  box-shadow: none;
  border-radius: 8px 8px 0 0;
  padding: 4px 16px;
  position: relative;
  z-index: 1;
  transition: none;
  min-width: 0;
}
.W3orC2Go0VD5GEJL5mb9 button.folder-tab-small-no-width p.REclXxp7ABYfww7Gj2hU,
.W3orC2Go0VD5GEJL5mb9 button.folder-tab-selected-small-no-width p.REclXxp7ABYfww7Gj2hU {
  margin: 0;
  font-size: 1.1em;
  font-weight: 600;
}
.W3orC2Go0VD5GEJL5mb9 button.folder-tab-small-no-width {
  background: #eef0f3;
  border: 1px solid #808080;
  color: #444343;
  margin-bottom: 2px;
}
.W3orC2Go0VD5GEJL5mb9 button.folder-tab-small-no-width:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.W3orC2Go0VD5GEJL5mb9 {
  /* Seamless into panel: no bottom border; overlaps panel top edge */
}
.W3orC2Go0VD5GEJL5mb9 button.folder-tab-selected-small-no-width {
  background: #fff;
  border: 2px solid #0669B3;
  border-bottom: none;
  color: #0669B3;
  margin-bottom: -2px;
}

.RBgsgr5_xPj4XzSKLLFn {
  border: 2px solid #0669B3;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
}

/* Without a body, selected tab keeps a full border (no empty panel to merge into) */
.l7U3JLzydcprrdQn33A5[data-has-body=false] .W3orC2Go0VD5GEJL5mb9 button.folder-tab-selected-small-no-width {
  margin-bottom: 0;
  border-bottom: 2px solid #0669B3;
  border-radius: 8px;
}

@media (max-width: 768px) {
  .W3orC2Go0VD5GEJL5mb9 {
    flex: 1;
    justify-content: flex-end;
  }
  .W3orC2Go0VD5GEJL5mb9 button {
    flex: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/SemesterConnectedPanel.module.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;AACA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;AAEJ;;AACA;EACI,aAAA;EACA,yBAAA;EACA,qBAAA;EACA,QAAA;EACA,eAAA;AAEJ;AAAI;EAPJ;IAQQ,WAAA;IACA,8BAAA;EAGN;AACF;;AAAA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;AAGJ;;AAAA;EACI,aAAA;EACA,qBAAA;EACA,QAAA;AAGJ;AADI;;EAEI,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;AAGR;AADQ;;EACI,SAAA;EACA,gBAAA;EACA,gBAAA;AAIZ;AAAI;EACI,mBAAA;EACA,yBAAA;EACA,cDvBC;ECwBD,kBAAA;AAER;AAAQ;EACI,YAAA;EACA,mBAAA;AAEZ;AAhCA;EAkCI,mEAAA;AACJ;AAAI;EACI,gBAAA;EACA,yBAjEO;EAkEP,mBAAA;EACA,cDpCK;ECqCL,mBAAA;AAER;;AAEA;EACI,yBAzEW;EA0EX,kBAzEW;EA0EX,gBAAA;EACA,gBAAA;AACJ;;AAEA,oFAAA;AAEI;EACI,gBAAA;EACA,gCAnFO;EAoFP,kBAnFO;AAmFf;;AAIA;EACI;IACI,OAAA;IACA,yBAAA;EADN;EAGM;IACI,OAAA;EADV;AACF","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$lt-highlight: #FAFAD2;\n$grey0: #EDF0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"global/Colors\";\n\n$panel-border: 2px solid $pearl-blue;\n$panel-radius: 8px;\n\n.root {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n}\n\n.tabRow {\n    display: flex;\n    justify-content: flex-end;\n    align-items: flex-end;\n    gap: 8px;\n    flex-wrap: wrap;\n\n    @media (max-width: 768px) {\n        width: 100%;\n        justify-content: space-between;\n    }\n}\n\n.schoolYearSelect {\n    display: flex;\n    align-items: center;\n    margin-bottom: 4px;\n}\n\n.tabs {\n    display: flex;\n    align-items: flex-end;\n    gap: 4px;\n\n    :global(button.folder-tab-small-no-width),\n    :global(button.folder-tab-selected-small-no-width) {\n        box-shadow: none;\n        border-radius: #{$panel-radius} #{$panel-radius} 0 0;\n        padding: 4px 16px;\n        position: relative;\n        z-index: 1;\n        transition: none;\n        min-width: 0;\n\n        p.primary {\n            margin: 0;\n            font-size: 1.1em;\n            font-weight: 600;\n        }\n    }\n\n    :global(button.folder-tab-small-no-width) {\n        background: #eef0f3;\n        border: 1px solid $grey3;\n        color: $grey4a;\n        margin-bottom: 2px;\n\n        &:disabled {\n            opacity: 0.5;\n            cursor: not-allowed;\n        }\n    }\n\n    /* Seamless into panel: no bottom border; overlaps panel top edge */\n    :global(button.folder-tab-selected-small-no-width) {\n        background: #fff;\n        border: $panel-border;\n        border-bottom: none;\n        color: $pearl-blue;\n        margin-bottom: -2px;\n    }\n}\n\n.panelBody {\n    border: $panel-border;\n    border-radius: $panel-radius;\n    background: #fff;\n    overflow: hidden;\n}\n\n/* Without a body, selected tab keeps a full border (no empty panel to merge into) */\n.root[data-has-body=\"false\"] .tabs {\n    :global(button.folder-tab-selected-small-no-width) {\n        margin-bottom: 0;\n        border-bottom: $panel-border;\n        border-radius: $panel-radius;\n    }\n}\n\n@media (max-width: 768px) {\n    .tabs {\n        flex: 1;\n        justify-content: flex-end;\n\n        :global(button) {\n            flex: 1;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export var root = `l7U3JLzydcprrdQn33A5`;
export var tabRow = `EcJ0I7x4nEUGJH0gF64g`;
export var schoolYearSelect = `A_6g9d9koNAcd_yZsEUW`;
export var tabs = `W3orC2Go0VD5GEJL5mb9`;
export var primary = `REclXxp7ABYfww7Gj2hU`;
export var panelBody = `RBgsgr5_xPj4XzSKLLFn`;
export default ___CSS_LOADER_EXPORT___;
